import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const ax = (m, url, data) => axios({ method: m, url: `${API}${url}`, data, withCredentials: true });

const SiteFilesTab = () => {
  const [files, setFiles] = useState([]);
  const [slug, setSlug] = useState('');
  const [content, setContent] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    ax('get', '/api/admin/files').then(r => setFiles(r.data.files)).catch(() => setMsg('Failed to load file list'));
  }, []);
  useEffect(() => { load(); }, [load]);

  const open = (s) => {
    setSlug(s); setMsg(''); setContent('');
    ax('get', `/api/admin/files/${s}`).then(r => setContent(r.data.content)).catch(() => setMsg('Failed to load file'));
  };

  const save = async () => {
    setBusy(true); setMsg('');
    try {
      await ax('put', `/api/admin/files/${slug}`, { content });
      setMsg('Saved — live immediately');
      load();
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Save failed');
    }
    setBusy(false);
  };

  const rollback = async () => {
    setBusy(true); setMsg('');
    try {
      await ax('post', `/api/admin/files/${slug}/rollback`);
      setMsg('Rolled back to previous version');
      open(slug); load();
    } catch (e) {
      setMsg(e.response?.data?.detail || 'No previous version');
      setBusy(false);
    }
  };

  const active = files.find(f => f.slug === slug);

  return (
    <div className="tab-content" data-testid="sitefiles-tab">
      <div className="tab-header">
        <h2>Site Files</h2>
        <p>Edit embedded HTML and data files. Changes go live immediately — no deploy needed.</p>
      </div>
      {msg && <p style={{ background: '#FFF3CD', padding: '8px 12px', fontSize: 13 }} data-testid="sitefiles-msg">{msg}</p>}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
        {files.map(f => (
          <button key={f.slug} onClick={() => open(f.slug)}
            style={{ padding: '8px 14px', border: '1px solid #ccc', fontSize: 13,
                     background: slug === f.slug ? '#1a1a1a' : '#fff', color: slug === f.slug ? '#fff' : '#1a1a1a', cursor: 'pointer' }}
            data-testid={`sitefiles-pick-${f.slug}`}>
            {f.label}{f.db_managed ? ' •' : ''}
          </button>
        ))}
      </div>
      {slug && (
        <div>
          <p style={{ fontSize: 12, color: '#666', margin: '0 0 8px' }}>
            {active?.db_managed
              ? `Database version (last saved ${active.updated_at ? new Date(active.updated_at).toLocaleString() : '—'})`
              : 'Currently serving the built-in file. Saving creates an editable database version.'}
          </p>
          <textarea value={content} onChange={e => setContent(e.target.value)} spellCheck={false}
            style={{ width: '100%', minHeight: 420, padding: 10, fontFamily: 'monospace', fontSize: 12, border: '1px solid #ccc' }}
            data-testid="sitefiles-editor" />
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            <button onClick={save} disabled={busy || !content.trim()} style={{ padding: '8px 18px' }} data-testid="sitefiles-save">
              {busy ? 'Working…' : 'Save & publish'}
            </button>
            <button onClick={rollback} disabled={busy || !active?.has_previous} style={{ padding: '8px 18px' }} data-testid="sitefiles-rollback">
              Rollback to previous
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SiteFilesTab;
